module.exports = __webpack_public_path__ + "h5/img/master_17.8a2703c7.jpg";